import React from 'react'
import { ReactComponent as LogoImage } from './logo_tryangly.svg'
import './TryanglyLogo.scss'

const TryanglyLogo: React.FC<{}> = () => <LogoImage />

export default TryanglyLogo
